import React from 'react';
import PropTypes from "prop-types";
import { Row } from 'antd';
import { EditButtonComponent } from '../../../../../../../CommonComponents/CTA/Buttons';
import { GrantSectionHeading } from '../../../style';

export default function  Heading({
  title,
  edit,
  handleEdit,
  id
}) {
  return (
    <Row type="flex">
      {title && (
        <GrantSectionHeading>
          {title}
        </GrantSectionHeading>
      )}
      {edit && (
        <EditButtonComponent id={ id ? id : null } className="ml-10" buttonName="Edit" boldFont={false} clicked={handleEdit} />
      )}
    </Row>
  );
}

Heading.propTypes = {
  title: PropTypes.string,
  edit: PropTypes.bool,
  handleEdit: PropTypes.func,
  id: PropTypes.string
};
